import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Building, SearchNormal1 } from "iconsax-react";
import { useDispatch, useSelector } from "react-redux";
import { fetchBusinessList } from "../../redux/slices/businessSlice"; 
import { marchantgraphic } from "../../assets/ImageExports"; 

const Merchant = () => {
  const [searchdata, setSearchdata] = useState({ search: "" });
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { data: businesses, loading, error } = useSelector((state) => state.businesslist);

  useEffect(() => {
    dispatch(fetchBusinessList());
  }, [dispatch]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSearchdata((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const filteredBusinesses = (businesses || []).filter((business) =>
    business.member_firm_name.toLowerCase().includes(searchdata.search.toLowerCase())
  );

  if (loading) return <p>Loading businesses...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <div
      style={{
        backgroundImage: `url(${marchantgraphic})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        minHeight: "100vh",
        padding: "20px"
      }}
    >
      <div>
        <p className="soft_track">ₒₙbₒₐᵣd ₐₛ ₐ ₘₑᵣcₕₐₙₜ</p>
      </div>

      <div className="form-container1">
        <form className="custom-form">
          <div className="form-group">
            <label className="floating-label">
              See Your Organization<span className="stag_star">*</span>
            </label>
            <input
              type="text"
              name="search"
              onChange={handleChange}
              value={searchdata.search}
              required
              className="form-input"
            />
            <div className="icon-under-input">
              <SearchNormal1
                size="25"
                color="#2c3e50"
                variant="TwoTone"
                className="icon_search"
              />
            </div>
          </div>
        </form>
      </div>

      <div className="root_serch">
        <div className="search-result-list">
          {searchdata.search.length > 0 &&
            (filteredBusinesses.length > 0 ? (
              <ul>
                {filteredBusinesses.map((business) => (
                  <li
                    key={business.member_id}
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      navigate("/marchantonbordpage", { state: { business } })
                    }
                  >
                    <span>
                      <Building size="20" color="#007bff" variant="Bold" />
                    </span>
                    <span className="font_trck">
                      {business.member_firm_name}
                    </span>
                  </li>
                ))}
              </ul>
            ) : (
              <p>No matching organizations found.</p>
            ))}
        </div>
      </div>
    </div>
  );
};

export default Merchant;
